/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export const EDIT_TELEMETRY_SETTING_ID = 'telemetry.editStats.enabled';
export const AI_STATS_SETTING_ID = 'editor.aiStats.enabled';
